import styled from 'styled-components';
import Button from '../../../atoms/Button';

export const Field = styled(Button)`
height: 3rem;
&& {
    margin: 1rem;

}
`; 